import { getList, getSingle, Api } from "@/plugins/api"

export const getFormulaire = (id) => {
  return Api.get("/formulaires/" + id)
}